import { gql } from "@apollo/client";

export interface LCFeedCurve {
    feedcurve_id: number
    feed_limit: number
    pass_feed: number
    stimuli: number
    milestoneCount: number
    componentCount: number
    feedcurve_milestones: LCFeedcurveMilestones[]
    feedcurve_components: LCFeedcurveComponents[]
}

export interface LCFeedcurveMilestones {
    milestoneId: number 
    milestoneIndex: number
}

export interface LCFeedcurveComponents { 
    componentId: number 
    gram_per_minute: number 
}

export const LC_FEED_CURVE = gql`
query GetLcFeedCurve($domain: String!, $lanControllerId: Int!) {
	controller {
		lcFeedCurve(domain: $domain, lanControllerId: $lanControllerId) {
			feedcurve_id
			feed_limit
			pass_feed
			stimuli
			milestoneCount
			componentCount
			feedcurve_milestones {
				milestoneId
				milestoneIndex
			}
			feedcurve_components {
				componentId
				gram_per_minute
			}
		}
	}
}
`

export interface LCFeedCurveResponse {
	controller: {
		lcFeedCurve: LCFeedCurve[] | null
	}
}

export interface LCFeedCurveArgs {
	domain: string;
	lanControllerId: number;
}

